SNI.Application.addModule('promo-collage', function(context) {

  return {
    behaviors: ['lazy-load']
  };

});
